import { Directive, HostBinding, Input, Optional, Self } from '@angular/core';
import { NgControl } from '@angular/forms';

export type BkInputSize = 'sm' | 'md' | 'lg';

/**
 * Applies design-system hooks to a native form control (`<input>`, `<select>`,
 * `<textarea>`) that already carries Bootstrap's `.form-control` / `.form-select`
 * class. The visual baseline is global (`_input.scss`); this directive adds the
 * parts CSS cannot do on its own: automatic error styling driven by the Angular
 * control state, plus an optional explicit size.
 *
 * Usage: `<input class="form-control" name="x" [(ngModel)]="x" bkInput>`
 *        `<select class="form-control" formControlName="y" bkInput size="sm">`
 */
@Directive({
  selector: '[bkInput]',
})
export class BkInputDirective {
  @Input() size?: BkInputSize;

  constructor(@Optional() @Self() private readonly ngControl: NgControl | null) {}

  @HostBinding('class.bk-input') readonly hostClass = true;

  @HostBinding('attr.data-bk-size')
  get sizeAttr(): string | null {
    return this.size ?? null;
  }

  @HostBinding('class.bk-input--invalid')
  get invalid(): boolean {
    const control = this.ngControl?.control;
    return !!control && control.invalid && (control.touched || control.dirty);
  }
}
